//Search
export const TECHNICAL_REVIEWER_SEARCH_START_LOADING = "TECHNICAL_REVIEWER_SEARCH_START_LOADING";
export const TECHNICAL_REVIEWER_SEARCH_END_LOADING = "TECHNICAL_REVIEWER_SEARCH_END_LOADING";
export const TECHNICAL_REVIEWER_SEARCH_LOADED = "TECHNICAL_REVIEWER_SEARCH_LOADED";
export const SET_TECHNICAL_REVIEWER_FILTER = "SET_TECHNICAL_REVIEWER_FILTER";

//Edit
export const TECHNICAL_REVIEWER_START_LOADING = "TECHNICAL_REVIEWER_START_LOADING";
export const TECHNICAL_REVIEWER_END_LOADING = "TECHNICAL_REVIEWER_END_LOADING";
export const TECHNICAL_REVIEWER_LOADED = "TECHNICAL_REVIEWER_LOADED";
